"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cursorMove = exports.deactivateDatasheetCollaborator = exports.activeDatasheetCollaborator = void 0;
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
const activeDatasheetCollaborator = (payload, resourceId) => {
    return {
        type: action_constants_1.DATASHEET_ACTIVE_COLLABORATOR,
        datasheetId: resourceId,
        payload,
    };
};
exports.activeDatasheetCollaborator = activeDatasheetCollaborator;
const deactivateDatasheetCollaborator = (payload, resourceId) => {
    return {
        type: action_constants_1.DATASHEET_DEACTIVATE_COLLABORATOR,
        datasheetId: resourceId,
        payload,
    };
};
exports.deactivateDatasheetCollaborator = deactivateDatasheetCollaborator;
const cursorMove = (payload, datasheetId) => {
    return {
        type: action_constants_1.CURSOR_MOVE,
        datasheetId,
        payload,
    };
};
exports.cursorMove = cursorMove;
//# sourceMappingURL=collaborators.js.map